import { RhIcon } from "@rhythm-ui/react";
import React from "react";

const DrawerDetailsResultNavigation = ({
  resultCount,
  resultNumber,
  showNextResult,
  showPrevResult,
  resultLabel = "records",
}: {
  resultCount: number;
  resultNumber: number;
  showNextResult: () => void;
  showPrevResult: () => void;
  resultLabel?: string;
}) => {
  return (
    <div className="flex items-center justify-end h-12 px-txl navigation-bg">
      <div className="flex justify-end gap-tsm">
        <p className="text-light">
          {resultNumber} of {resultCount} {resultLabel}
        </p>
        <div className="flex items-center gap-tsm">
          <RhIcon
            onClick={showPrevResult}
            icon={"material-symbols:chevron-left-rounded"}
            className="text-xl cursor-pointer"
          />
          <RhIcon
            onClick={showNextResult}
            className="text-xl cursor-pointer"
            icon={"material-symbols:chevron-right-rounded"}
          />
        </div>
      </div>
    </div>
  );
};

export default DrawerDetailsResultNavigation;
